async function createCard(url, card) {
    url = url + '/v1/coupon/create'
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(card)
    });
    return await response;
}

export { createCard }